import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest, all, fork, take } from 'redux-saga/effects';
import { change } from 'redux-form';

import { SEARCH_RECORD_EXPORT_FILE_DOWNLOAD } from '../../constants/constant_action_types';

import * as common from '../sagasCommon';
import * as SagaType from '../../constants/constant_saga_types';

import * as api from '../../services/csv_export/api_csv_export';
import * as apiCommon from '../../services/apiCommon';

import { getErrorMessage } from '../../utils';
import { parseSearchRecordCompareFilters } from '../record/saga_record';

export default function* (ksApp) {
  return yield all([
    fork(fetchListCSVExportSaga, ksApp),
    fork(deleteCSVExportSaga, ksApp),
    fork(fetchCSVExportForEditSaga, ksApp),
    fork(saveCSVExportSaga, ksApp),
    fork(exportCsvExportSaga, ksApp),
    fork(fetchCsvExportHistory, ksApp),
    fork(downloadExportSaga),
  ]);
}



export function* fetchListCSVExportSaga(feathersApp) {
  yield takeLatest('FETCH_LIST_CSV_EXPORT', callListCSVExport, feathersApp);
}
function* callListCSVExport(feathersApp, action) {
  const { filters, silent } = action;

  yield common.showProgressListTable(silent);
  try {
    const dataParams = { filters, list_type: 'csv_export' };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}



export function* deleteCSVExportSaga(feathersApp) {
  yield takeEvery('DELETE_CSV_EXPORT', callDeleteCSVExport, feathersApp);
}
function* callDeleteCSVExport(feathersApp, action) {
  const result = yield deleteCSVRecord(feathersApp, action);
  if (result) {
    browserHistory.push('/admin/search_record');
  }
}
function* deleteCSVRecord(feathersApp, action) {
  yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  try {
    const { id } = action;
    let result = null;
    if (id) {
      const state = yield select();
      const { tenant, user } = state;
      const { id } = action;
      const params = { tenant, user, id };
      result = yield call(api.deleteCSVExport, feathersApp, params);
    }
    yield put({ type: 'DELETE_RECORD_DONE', payload: { id, docType: 'csv_export' } });
    return result;
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error })
  }
}



export function* fetchCSVExportForEditSaga(feathersApp) {
  yield takeEvery('FETCH_CSV_EXPORT_FOR_EDIT', callFetchCSVExportForEdit, feathersApp);
}
function* callFetchCSVExportForEdit(feathersApp, action) {
  const { tenant, user } = yield select();
  const { id, silent } = action;
  try {
    if (id) {
      yield common.showProgressDataById(silent);
      const fetchParams = { tenant, user, id };
      const doc = yield call(api.fetchCSVExportForEdit, feathersApp, fetchParams);

      doc.compare_filters = yield call(parseSearchRecordCompareFilters, doc.compare_filters);

      yield common.doneDataById(doc);
    }
  } catch (error) {
    yield put({ type: 'FETCH_DATA_BY_ID_ERROR', error: error });
  }
}



function* saveCSVExportSaga(ksApp) {
  yield takeEvery(['SAVE_CSV_EXPORT', 'SAVE_EXPORT_CSV_EXPORT'], callSaveCSVExport, ksApp);
}
function* callSaveCSVExport(ksApp, action) {
  yield common.showProgressSaveRecord();
  const { user, record } = yield select();
  const { data } = action;

  try {
    const result = yield call(api.saveCSVExport, ksApp, {
      user,
      data,
      record
    });
    const id = result && result.id;
    const reference_id = result && result.reference_id

    switch (action.type) {
      case 'SAVE_EXPORT_CSV_EXPORT':
        yield delay(500);
        yield call(callExportCsvRecord, ksApp, { payload: {
          id,
          reference_id,
          export_type: data.export_type,
        }});
        break;

      default: break;
    }

    yield callFetchCSVExportForEdit(ksApp, { id, silent: true });
    yield common.doneSaveRecord(result, 'Search record was saved');
    if (action.type ===  'SAVE_CSV_EXPORT') {
      browserHistory.push(`/admin/search_record/edit/${id}`);
    }
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}



export function* exportCsvExportSaga(feathersApp) {
  yield takeLatest('EXPORT_CSV', callExportCsvRecord, feathersApp);
}
function* callExportCsvRecord(feathersApp, action) {
  yield put({ type: SagaType.CSV_EXPORT_START_INPROGRESS, payload: { exporting: true } });
  yield delay(500);
  try {
    const { payload } = action;
    const {
      export_type,
      filters,
      id,
      query,
      reference_id = '',
      sorting,
    } = payload;

    if (id) {
      yield call(api.exportCsvRecord, feathersApp, { 
        export_type,
        filters,
        id,
        query,
        sorting,
      });

      yield put({ type: SagaType.CSV_EXPORT_START_DONE });
      yield put({ type: 'FETCH_RUN_HISTORY', reference_id });
      browserHistory.push('/admin/job_status');
      yield take('FETCH_LIST_JOB');
      yield put(change('JobSearchForm', 'reference_id', reference_id));
    }
  } catch (error) {
    yield put({ 
      type: SagaType.CSV_EXPORT_START_ERROR, 
      payload: { 
        error: { 
          isError: true,
          message: getErrorMessage(error), 
        } 
      } 
    });
    
    yield common.showErrorSaveRecord(error);
  }
}



export function* fetchCsvExportHistory(ksApp) {
  yield takeLatest('FETCH_RUN_HISTORY', callFetchCsvExportHistory, ksApp);
}
function* callFetchCsvExportHistory(ksApp, action) {
  try {
    yield put({ type: SagaType.FETCHING_RECORD_EXPORT_HISTORY })
    yield delay(1000);
    const { reference_id } = action;

    if (reference_id) {
      const filters = { csv_export_reference: reference_id };
      const dataParams = {
        filters,
        list_type: 'csv_export/run'
      };
      const tableData = yield call(apiCommon.getDocs, ksApp, dataParams);
      yield put({ type: SagaType.DONE_FETCH_RECORD_EXPORT_HISTORY, history: tableData.data });
    }
  } catch (error) {
    console.error('ERROR @fetchCsvExportHistory : ', error);
  }
}

function* downloadExportSaga() {
  yield takeLatest(SEARCH_RECORD_EXPORT_FILE_DOWNLOAD, callDownloadExport);
}

function* callDownloadExport(action) {
  try {
    const { payload } = action;
    const { path, subType } = payload;
    const { app } = yield select();
    const { api_host_url, api_access_token } = app;
    const fileName = path.split('/').pop();

    yield call(api.downloadExport, {
      api_access_token,
      api_host_url,
      fileName,
      subType,
    });
  } catch (err) {
    console.error('@callDownloadExport error', err);
  }
}
